import { useEffect, useState } from "react";

export const useGenericAutocomplete = <T>(
  option: T | null,
  dependence: string,
) => {
  const [selectAutocompleteValue, setSelectAutocompleteValue] =
    useState<T | null>(null);

  useEffect(() => {
    setSelectAutocompleteValue(option);
  }, [dependence]);

  const handleSelectAutocompleteOption = (newOption: T | null) => {
    setSelectAutocompleteValue(newOption);
  };

  return {
    selectAutocompleteValue,
    handleSelectAutocompleteOption,
  };
};
